import { render, staticRenderFns } from "./pointsExchange.vue?vue&type=template&id=3b2fb2a7"
import script from "./pointsExchange.vue?vue&type=script&lang=js"
export * from "./pointsExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports